import { render, staticRenderFns } from "./UserBirthdays.vue?vue&type=template&id=1c379c14"
import script from "./UserBirthdays.js?vue&type=script&lang=js&external"
export * from "./UserBirthdays.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports